module.exports = __webpack_public_path__ + "img/11.32ed1e4a.jpg";